import { standardAuthFetch } from "@/data-access/core/authenticatedFetch";
import { apiEndpointBaseUrl } from "@/data-access/core/constants";

/** POST/stream URL for Herald chat generate (AI SDK DefaultChatTransport). */
export const chatGenerateUrl = `${apiEndpointBaseUrl}/chat/generate`;

/** GET resume URL for AI SDK `DefaultChatTransport` reconnect (backend streaming resume). */
export const chatConversationStreamUrl = (conversationId: string): string =>
  `${apiEndpointBaseUrl}/chat/${conversationId}/stream`;

/** Stops one active server-side assistant turn without coupling reader disconnects to cancellation. */
export const stopConversationStream = async (
  conversationId: string,
  assistantMessageId: string,
): Promise<void> => {
  const response = await standardAuthFetch(
    `${chatConversationStreamUrl(conversationId)}/stop`,
    {
      method: "POST",
      body: JSON.stringify({ assistant_message_id: assistantMessageId }),
    },
  );

  if (!response.ok) {
    throw new Error("Unable to stop the response on the server.");
  }
};

/** POST JSON `{ html }` → PDF bytes (`Content-Disposition` filename optional). */
export const agenticPdfUrl = `${apiEndpointBaseUrl}/agentic/pdf`;
